import React, { useState } from "react";
import {
  Card,
  Col,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import classNames from "classnames";
import Dropzone from "react-dropzone";
import { useEffect } from "react";
import PropTypes from "prop-types";

const NibbleInputImage = ({
  md = 6,
  label = "label",
  fieldName = "field_name",
  itemFile = null,
  validation,
  postFileFunction = () => { },
  accept = { "image/*": [] },
  relatedModelFile = null,
  index = null,
}) => {
  const [newImage, setNewImage] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  const relatedFile = validation.values[relatedModelFile];

  useEffect(() => {
    if (relatedFile) {
      setNewImage(relatedFile);
    }
  }, [relatedFile]);

  useEffect(() => {
    if (itemFile) {
      setNewImage(itemFile);
    }
  }, [itemFile]);

  const handleAcceptedFiles = async (files) => {
    console.log(files[0]);
    setUploadingFile(true);
    try {
      const response = await postFileFunction(files[0], index);
      setNewImage(response);
      validation.setFieldValue(fieldName, response.id, true);
    } catch (error) { }

    setUploadingFile(false);
  };

  return (
    <Col md={md}>
      {/* {itemFile && !newImage && (
        <div
          className={classNames({
            "pt-2": true,
            "mb-3": true,
          })}
        >
          <Label className="form-label">{label}</Label>
          {itemFile.mimetype?.includes("image/") ? (
            <p>
              <img height="100" src={itemFile.url}></img>
            </p>
          ) : (
            <a
              href={itemFile.url}
              target="_blank"
              title="Ver archivo"
              className="d-block pb-2"
            >
              <span className="d-inline-block me-1">Ver archivo</span>
              <i className="ri-file-download-line fs-3"></i>
            </a>
          )}
        </div>
      )} */}

      {newImage && (
        <div
          className={classNames({
            "pt-2": true,
            "mb-3": true,
          })}
        >
          <Label className="form-label">{label}</Label>
          {newImage.mimetype?.includes("image/") ? (
            <p>
              <img height="100" src={newImage.url}></img>
            </p>
          ) : (
            <a
              href={newImage.url}
              target="_blank"
              title="Ver archivo"
              className="d-block pb-2"
              rel="noreferrer"
            >
              <span className="d-inline-block me-1">Ver archivo</span>
              <i className="ri-file-download-line fs-3"></i>
            </a>
          )}
          <button
            type="button"
            onClick={() => {
              setNewImage(null);
              validation.setFieldValue(fieldName, itemFile?.id ?? null);
            }}
            className="btn btn-primary btn-sm save-user mt-1"
          >
            <i className="fas fa-sync"></i> Cambiar
          </button>
        </div>
      )}
      {!newImage && (
        <div
          className={classNames({
            "d-none": false,
            "is-invalid": !!(
              validation.touched[fieldName] && validation.errors[fieldName]
            ),
            "mt-3": true,
          })}
        >
          <Label className="form-label">{label}</Label>
          <br />
          {!newImage && (
            <Dropzone
              onDrop={(acceptedFiles) => {
                handleAcceptedFiles(acceptedFiles);
              }}
              onFileDialogOpen={() => {
                validation.setFieldTouched(fieldName, true, true);
              }}
              accept={accept}
            >
              {({ getRootProps, getInputProps }) => (
                <div className="dropzone" style={{ minHeight: "120px" }}>
                  <div
                    className="text-center needsclick mt-2"
                    {...getRootProps()}
                  >
                    <input accept={accept} {...getInputProps()} />
                    <div className="mb-1">
                      <i className="display-5 text-muted bx bx-cloud-upload" />
                    </div>

                    {uploadingFile ? (
                      <Spinner />
                    ) : (
                      <h5>Arrastra archivos aquí o da clic en cargar</h5>
                    )}
                  </div>
                </div>
              )}
            </Dropzone>
          )}
        </div>
      )}
      {validation.touched[fieldName] && validation.errors[fieldName] ? (
        <FormFeedback type="invalid" className="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      ) : null}
    </Col>
  );
};

NibbleInputImage.propTypes = {
  md: PropTypes.number,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  itemFile: PropTypes.object,
  validation: PropTypes.object.isRequired,
  postFileFunction: PropTypes.func,
  accept: PropTypes.string,
  relatedModelFile: PropTypes.string,
  index: PropTypes.number,
}

export default NibbleInputImage;
